import { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Input, InputNumber, Button, Form } from "antd";
import { SyncOutlined, LoadingOutlined } from "@ant-design/icons";
import { postRequest } from "../../api/http";
import LoginApi from "../../api/LoginApi";
import { ReactComponent as Logo } from "../../assets/images/LogoWith.svg";
import "./Login.scss";
import toastr from "toastr";
import firebaseAuth from "./firebase";
import { RecaptchaVerifier ,signInWithPhoneNumber} from "firebase/auth";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const [activeIndex, setActiveIndex] = useState(0);
  const [borderColor, setBorderColor] = useState(); // Default border color

  const token = localStorage.getItem("token");
  const refreshToken=localStorage.getItem("refreshToken");
  useEffect(() => {
    if (token && refreshToken) {
      navigate("/");
    }
  }, [token, navigate,refreshToken]);
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "email") {
      setEmail(value);
    }
    if (name === "password") {
      setPassword(value);
    }
  };

  const handleRoleClick = (index) => {
    setActiveIndex(index);
    if (index === 0) {
      setBorderColor("#ed9f0b"); // Color for CA Login tab
    } else if (index === 1) {
      setBorderColor("#ed9f0b"); // Color for PO Login tab
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitted(true);
    if (!(email && password)) {
      return;
    }
    setLoading(true);
    try {
      const response = await postRequest(LoginApi.login(), { email, password });
      if (response.role !== "PLACEMENT_OFFICER") {
        throw new Error("Invalid credentials or role");
      }
      localStorage.setItem("token", response.accessToken);
      localStorage.setItem("refreshToken", response.refreshToken);

      
      const redirectTo = location?.state?.from === "/forgetPassword" ? "/" : location?.state?.from || "/";
      navigate(redirectTo);
    } catch (error) {
      console.log("error", error);
      if (error !== undefined) {
        if (error.status === 500) {
          toastr.error(error.error);
        } else {
          toastr.error(error.message);
        }
        setError(error.message);
        setLoading(false);
      } else {
        setLoading(false);
        toastr.error("Please check your internet connection");
        window.location.reload();
      }
    }
  };

  const handleCAFormSubmit = async (values) => {
    try {
      console.log("came to try block")
      setLoading(true);
      
      const recaptchaVerifier = window.recaptchaVerifier;
      const phoneWithCode = "+91" + values.phone;
      // const session = await postRequest(LoginApi.getOtp(), {
      //   phoneNumber: phoneWithCode,
      //   recaptchaToken: reCaptchaToken,
      // });
      // setLoading(false);
      const confirmationResult = await signInWithPhoneNumber(

        firebaseAuth,

        phoneWithCode,

        recaptchaVerifier

      );
      window.confirmationResult = confirmationResult;

      navigate("/verifyOtp", {

        state: {

          sessionInfo: confirmationResult.verificationId,

          phone: phoneWithCode,

        },

      });
    } catch (e) {
      console.log(e)
      toastr.error(e || "Something went wrog...");
      setLoading(false);
    }
  };
 

  useEffect(() => {
    // if (!window.recaptchaVerifier) {
    window.recaptchaVerifier = new RecaptchaVerifier(
      firebaseAuth,
      "recaptcha",
      {
        size: "invisible",
        callback: (response) => {
          console.log(response);
          return response;
        },
      }
    );
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  function ImageLogo() {
    return <Logo width={200} height={38} />;
  }

  return (
    <div className="loginPage">
      <div className="loginContainer">
        <div className="loginRow">
          <div className="loginCol loginBg"></div>
          <div className="loginCol loginForm">
            <div className="loginLogo">
              <Link to="/login">
                <ImageLogo />
              </Link>
            </div>
            <div className="loginFormBox">
              <div className="loginRoleBox">
                <div
                  className="loginRoleCol"
                  style={{
                    borderColor: activeIndex === 0 ? borderColor : "#837f7b",
                  }}
                  onClick={() => handleRoleClick(0)}
                >
                  CA Login
                </div>
                <div
                  className="loginRoleCol"
                  style={{
                    borderColor: activeIndex === 1 ? borderColor : "#837f7b",
                  }}
                  onClick={() => handleRoleClick(1)}
                >
                  PO Login
                </div>
              </div>

              {activeIndex === 0 ? (
                  <div className="inputContainer">
                    <div className="textInput">
                      <Form
                        name="userRegistrationForm"
                        onFinish={handleCAFormSubmit}
                        requiredMark={false}
                        autoComplete="off"
                      >
                        <Form.Item
                          name="phone"
                          // label="Phone Number"
                          validateFirst={true}
                          rules={[
                            {
                              required: true,
                              message: "Please enter your phone number!",
                            },
                            {
                              validator(_, value) {
                                if (value.toString().length === 10)
                                  return Promise.resolve();
                                return Promise.reject(
                                  new Error("Invalid phone number")
                                );
                              },
                            },
                          ]}
                        >
                          <InputNumber
                            addonBefore={<span>+91</span>}
                            controls={false}
                            maxLength={10}
                            min={0}
                            style={{ width: "100%" }}
                            placeholder="Phone Number"
                          />
                        </Form.Item>

                        <Button
                          id="submit-btn"
                          type="primary"
                          htmlType="submit"
                          disabled={loading}
                          className="button-primary form-submit-btn text-regular get-opt-btn"
                        >
                          {loading && (
                            <LoadingOutlined
                              style={{ color: "rgb(253 161 68)" }}
                            />
                          )}
                          <span style={{ marginLeft: 10 }}>Get OTP</span>
                        </Button>
                      </Form>
                    </div>
                  </div>
              ) : (
                <form name="form" action="">
                  <div
                    className={
                      "form-group" + (submitted && !email ? " has-error" : "")
                    }
                  >
                    <Input
                      placeholder="Email"
                      className="form-control login-email"
                      name="email"
                      value={email}
                      onChange={handleChange}
                    />
                    {submitted && !email && (
                      <div className="help-block">Email is required</div>
                    )}
                  </div>
                  <div
                    className={
                      "form-group" +
                      (submitted && !password ? " has-error" : "")
                    }
                  >
                    <Input.Password
                      placeholder="Password"
                      className="form-control"
                      name="password"
                      value={password}
                      onChange={handleChange}
                    />
                    {submitted && !password && (
                      <div className="help-block">Password is required</div>
                    )}
                  </div>
                  <div className="form-group submitRow">
                    <div className="loadingSpin">
                      {loading && <SyncOutlined spin />}
                    </div>
                    <input
                      type="submit"
                      disabled={loading}
                      className="loginBtn"
                      onClick={handleSubmit}
                      value="Login"
                    />
                  </div>
                  {error && (
                    <div className="redMandatory">
                      Please enter correct email & password
                    </div>
                  )}
                </form>
              )}

              <div className="loginCopyRight">
                <p>Terms and Conditions, Copyrights @TimBuckDo</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="recaptcha" style={{ display: "none" }}></div>
    </div>
  );
}

export default Login;
